import { useEffect, useRef, useState } from "react";
import ModuleSlideInterface from "../../../Interfaces/ModuleSlideInterface";

const SlideSwiper = ({
  item,
  index,
}: {
  item: ModuleSlideInterface;
  index: number;
}) => {
  const [height, setHeight] = useState<number>(0);
  const imageRef = useRef<HTMLImageElement | null>(null);
  const [bigText, setBigText] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const textRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (textRef.current) {
      setShowButton(
        textRef.current.scrollHeight > textRef.current.clientHeight
      );
    }
  }, [item]);

  const handleImageLoad = () => {
    if (imageRef.current) {
      setHeight(imageRef.current.height);
    }
  };

  useEffect(() => {
    if (textRef.current) {
      if (bigText) {
        textRef.current.style.maxHeight = `${textRef.current.scrollHeight}px`;
      } else {
        textRef.current.style.maxHeight = "4.8rem";
      }
    }
  }, [bigText]);

  return (
    <div className="slidesBox">
      <div>
        <div key={index} className="visibleSlide" style={{ minHeight: height }}>
          <img
            className="visibleImage"
            src={`https://emir.gtsolifk.ru:4443/assets/${item.slide_file}&embedded=true`}
            alt=""
            onLoad={handleImageLoad}
            ref={imageRef}
          ></img>
          {item.slide_text && (
            <div className="slideTextBox">
              <div
                ref={textRef}
                dangerouslySetInnerHTML={{ __html: item.slide_text }}
                className={bigText ? "slideText" : "smallSlideText"}
              ></div>

              {showButton && (
                <div
                  className="slideTextButton"
                  onClick={() => {
                    setBigText(!bigText);
                  }}
                >
                  {bigText ? "Свернуть" : "Показать больше"}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SlideSwiper;
